export default "__VITE_ASSET__7fec10de__"